export default __webpack_public_path__ + "static/media/freeSubscription.b053f2fb.png";